module.exports = __webpack_public_path__ + "media/images/Media-f64e2a9d2f926f718c0528004ac83cc1.svg";